import { combine, createStore, sample } from 'effector';
import _ from 'lodash';
import $$api from 'models/api';
import { $isAdvisorClientPage, $pathname } from 'models/location';
import { $global } from 'models/store-global';

const $selectedClientId = createStore<number | null>(null);
const $submenu = createStore<string | null>(null);
const $advisorClientCommunity = createStore<any | null>(null);

export const $advisorClientPage = combine(
    $selectedClientId,
    $submenu,
    $advisorClientCommunity,
    (selectedClientId, submenu, selectedClientCommunity) => ({
        selectedClientId,
        submenu,
        selectedClientCommunity,
    }),
);

sample({
    clock: $pathname,
    filter: $isAdvisorClientPage,
    fn: (pathname) => +pathname.split('/')[3] || null,
    target: $selectedClientId,
});

sample({
    clock: $pathname,
    filter: $isAdvisorClientPage,
    fn: (pathname) => pathname.split('/')[4],
    target: $submenu,
});

sample({
    clock: $selectedClientId,
    filter: (selectedClientId): selectedClientId is number => selectedClientId !== null,
    target: $$api.participants.getCommunityFx,
});

sample({
    clock: combine(
        $global.map((global) => global?.advisorClient || null),
        $selectedClientId,
        (advisorClient, selectedClientId) =>
            (selectedClientId && advisorClient?.clients?.[selectedClientId]?.community) || null,
    ),
    filter: (community) => !_.isEqual(community, $advisorClientCommunity.getState()),
    target: $advisorClientCommunity,
});

sample({
    clock: $selectedClientId,
    filter: (selectedClientId): selectedClientId is number => selectedClientId !== null,
    target: $$api.qInstances.getInstancesFx,
});
